import {useId, useState, type ReactNode} from "react";
import {NotebookPen} from "lucide-react";
import {Textarea} from "@/components/ui/textarea.tsx";
import type Combatant from "@/encounter/model/Combatant.ts";
import {useCombatants} from "@/encounter/combatants/CombatantHooks.ts";
import CombatantEditDialog from "./CombatantEditDialog.tsx";

export default function EditNotesDialog({combatant, children}: {combatant: Combatant; children?: ReactNode}) {
    const {update} = useCombatants();
    const [notes, setNotes] = useState(combatant.notes ?? "");
    const inputId = useId();
    return <CombatantEditDialog title="Notizen anpassen" description="Besondere Hinweise für diesen Combatant im Encounter." wide
        trigger={children ?? <button type="button" aria-label="Notizen bearbeiten" className="flex cursor-pointer gap-2 hover:underline">
            <NotebookPen className="size-5 flex-none"/><span className="line-clamp-5 whitespace-pre-wrap text-xs">{combatant.notes || "Notizen hinzufügen"}</span>
        </button>}
        onOpen={() => setNotes(combatant.notes ?? "")}
        onSave={() => update([{...combatant, notes}], "confirmed")}>
        <label htmlFor={inputId} className="block space-y-2 text-sm">Notizen
            <Textarea id={inputId} rows={10} className="h-64" value={notes} onChange={event => setNotes(event.target.value)}/>
        </label>
    </CombatantEditDialog>;
}
